import React from "react";
import PropTypes from "prop-types";

import ConnectedBillingAddress from "./ConnectedBillingAddress";
import ConnectedStandardPaymentMethods from "./ConnectedStandardPaymentMethods";
import ConnectedCommitmentAgreement from "./ConnectedCommitmentAgreement";
import ConnectedDigitalWalletPaymentOptions from "./ConnectedDigitalWalletPaymentOptions";

const NewPaymentMethod = ({
    controlId,
    displayAddressPasswordAndNickname,
    displayDigitalWalletPaymentOptions,
    displayStandardPaymentMethods,
    formik,
    registrationHasCommitment,
}) => (
    <>
        {/* Apple Pay, PayPal and Venmo */}
        {displayDigitalWalletPaymentOptions && !registrationHasCommitment && (
            <div className="col col--12">
                <ConnectedDigitalWalletPaymentOptions
                    controlId={controlId}
                    formik={formik}
                />
            </div>
        )}
        {/* Credit card, and bank. P2P does not have invoices at this moment in time. */}
        {displayStandardPaymentMethods && (
            <div className="col col--12">
                <ConnectedStandardPaymentMethods
                    controlId={controlId}
                    formik={formik}
                />
            </div>
        )}
        {/* If password and payment nickname are added to P2P they will be nested in this logic */}
        {displayAddressPasswordAndNickname && (
            <div className="col col--12">
                <ConnectedBillingAddress
                    controlId={controlId}
                    formik={formik}
                />
            </div>
        )}
        {/* determine if one of the registrations has a active commitment then display checkbox if so */}
        {registrationHasCommitment && (
            <ConnectedCommitmentAgreement controlId={controlId} />
        )}
    </>
);

NewPaymentMethod.propTypes = {
    controlId: PropTypes.number.isRequired,
    displayAddressPasswordAndNickname: PropTypes.bool.isRequired,
    displayDigitalWalletPaymentOptions: PropTypes.bool.isRequired,
    displayStandardPaymentMethods: PropTypes.bool.isRequired,
    formik: PropTypes.shape({}).isRequired,
    registrationHasCommitment: PropTypes.bool.isRequired,
};

export default NewPaymentMethod;
